export default theme => ({
    control: base => ({
        ...base,
        border: 'none',
        position: 'relative',
        boxShadow: 'unset',
        borderRadius: 'unset',
        font: '300 13px Roboto, sans-serif',
        height: '40px',
        "@media (min-width: 901px)": {
            height: '50px'
        },
    }),
    singleValue: base => ({
        ...base,
        verticalAlign: 'middle',
        marginLeft: '0',
        marginTop: '5px',
    }),
    noOptionsMessage: base => ({
        ...base,
        textAlign: 'left',
    }),
    menu: base => {
        return {
            ...base,
            zIndex: '10',
            width: theme.docTypeSelectMenuWidth ? theme.docTypeSelectMenuWidth : '100%',
            borderRadius: '0',
            font: '300 13px Roboto, sans-serif',
        };
    },
    menuPortal: base => {
        return {
            ...base,
            zIndex: 9999,
        };
    },
    menuList: base => {
        return {
            ...base,
            width: 'auto',
            overflowX: 'hidden',
            maxHeight: '132px',
            padding: '0',
        };
    },
    input: base => {
        return {
            ...base,
            position: 'absolute',
            top: '10px',
            margin: '0',
        };
    },
    valueContainer: base => {
        return {
            ...base,
            height: '30px',
            padding: '2px 16px'
        };
    },
    indicatorSeparator: base => {
        return {
            ...base,
            display: 'none'
        };
    },
    indicatorsContainer: base => {
        return {
            pointer: 'cursor',
            ...base,
            position: 'absolute',
            top: 0,
            right: ' -4',
            left: 'auto',
            bottom: 0,
            '&:lang(ar)': {
                right: 'auto',
                left: '-4',
                background: 'red',
            }
        };
    },
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...base,
            backgroundColor: isFocused ? '#f5f5f5' : undefined,
            color: '#000',
            padding: '8px 16px',
            cursor: 'pointer',
            minHeight: '31px',
            ":active": {
                ...base[":active"],
                backgroundColor: '#f5f5f5'
            }
        };
    },
});